var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { md: "6", "no-margin": "", xs: "12" } },
    [
      _c(
        "w-row",
        { attrs: { stretch: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                {
                  style: { position: "relative" },
                  attrs: { "no-margin": "", center: "" },
                },
                [
                  _c("w-input", {
                    style: { flexShrink: 0, flexGrow: 1 },
                    attrs: {
                      disabled: !_vm.state.overrideFriendlyId,
                      label: _vm.$ct("sale-nr"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.sale.ComputedFriendlyID,
                      callback: function ($$v) {
                        _vm.$set(_vm.sale, "ComputedFriendlyID", $$v)
                      },
                      expression: "sale.ComputedFriendlyID",
                    },
                  }),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("edit-number"),
                          expression: "$ct('edit-number')",
                        },
                      ],
                      style: {
                        flexShrink: 0,
                        position: "absolute",
                        right: "0px",
                        top: "7px",
                      },
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          _vm.state.overrideFriendlyId =
                            !_vm.state.overrideFriendlyId
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "pen" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.sale.TypeID == 10
            ? _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      min: 0,
                      decimals: 0,
                      label: _vm.$ct("payment-days"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.frequencyDocumentPaymentDays,
                      callback: function ($$v) {
                        _vm.frequencyDocumentPaymentDays = $$v
                      },
                      expression: "frequencyDocumentPaymentDays",
                    },
                  }),
                ],
                1
              )
            : [
                _c(
                  "w-col",
                  { attrs: { xs: "12", lg: "6" } },
                  [
                    _c("w-date-picker", {
                      attrs: {
                        label: _vm.$ct("date-start"),
                        locale: _vm.locale,
                        value: _vm.sale.InvoiceDate,
                        fancy: "",
                        "popover-visibility": "focus",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.setInvoiceDate($event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { xs: "12", lg: "6" } },
                  [
                    _c("w-date-picker", {
                      attrs: {
                        label: _vm.$ct("date-end"),
                        locale: _vm.locale,
                        "min-date": _vm.sale.InvoiceDate,
                        fancy: "",
                        "popover-visibility": "focus",
                      },
                      model: {
                        value: _vm.sale.ExpirationDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.sale, "ExpirationDate", $$v)
                        },
                        expression: "sale.ExpirationDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
          _c(
            "w-toggle-group",
            {
              on: { input: _vm.saveToggleState },
              model: {
                value: _vm.toggleAddresses,
                callback: function ($$v) {
                  _vm.toggleAddresses = $$v
                },
                expression: "toggleAddresses",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "slot-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [_vm._v(" " + _vm._s(_vm.$ct("toggle-group-addresses")) + " ")]
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          items: _vm.selectAddresses,
                          label: _vm.$ct(
                            _vm.state.isPurchaseType
                              ? "address-invoice-supplier"
                              : "address-invoice"
                          ),
                          fancy: "",
                        },
                        model: {
                          value: _vm.sale.InvoiceAddressID,
                          callback: function ($$v) {
                            _vm.$set(_vm.sale, "InvoiceAddressID", $$v)
                          },
                          expression: "sale.InvoiceAddressID",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.sale.Contact
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-contact-search", {
                            attrs: {
                              "group-id": _vm.alternateDeliveryAddressGroupId,
                              fancy: "",
                              label: _vm.$ct("address-alt-delivery"),
                              tiny: "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.fetchContact($event)
                              },
                              "update-group": function ($event) {
                                _vm.alternateDeliveryAddressGroupId = $event
                              },
                            },
                            model: {
                              value: _vm.deliveryContactID,
                              callback: function ($$v) {
                                _vm.deliveryContactID = $$v
                              },
                              expression: "deliveryContactID",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", lg: "6" } },
                    [
                      _c("w-select", {
                        attrs: {
                          items: _vm.deliveryAddresses,
                          label: _vm.$ct("address-delivery"),
                          "empty-text": _vm.$ct("none"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.sale.DeliveryAddressID,
                          callback: function ($$v) {
                            _vm.$set(_vm.sale, "DeliveryAddressID", $$v)
                          },
                          expression: "sale.DeliveryAddressID",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", lg: "6" } },
                    [
                      _c(
                        "w-row",
                        {
                          style: { flexWrap: "nowrap" },
                          attrs: { "no-margin": "" },
                        },
                        [
                          _c("w-date-picker", {
                            style: { flexGrow: 1, flexShrink: 1 },
                            attrs: {
                              label: _vm.$ct("date-delivery"),
                              local: _vm.locale,
                              fancy: "",
                              "popover-visibility": "focus",
                            },
                            model: {
                              value: _vm.sale.DeliveryDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.sale, "DeliveryDate", $$v)
                              },
                              expression: "sale.DeliveryDate",
                            },
                          }),
                          _vm.sale.DeliveryDate
                            ? _c(
                                "w-button",
                                {
                                  style: { flexShrink: 0, flexGrow: 0 },
                                  attrs: { flat: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.sale.DeliveryDate = null
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "times" } })],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-toggle-group",
            {
              on: { input: _vm.saveToggleState },
              model: {
                value: _vm.toggleDiscounts,
                callback: function ($$v) {
                  _vm.toggleDiscounts = $$v
                },
                expression: "toggleDiscounts",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "slot-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [_vm._v(" " + _vm._s(_vm.$ct("toggle-group-discounts")) + " ")]
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", lg: "6" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          label: _vm.$ct("payment-before-discount-percent"),
                          value: _vm.sale.PaymentBeforeDiscountPercent,
                          fancy: "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setPaymentBeforeDiscountPercent($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", lg: "6" } },
                    [
                      _c("w-date-picker", {
                        attrs: {
                          disabled:
                            _vm.sale.PaymentBeforeDiscountPercent == 0.0,
                          label: _vm.$ct("payment-before-discount-date"),
                          "max-date": _vm.sale.ExpirationDate,
                          "min-date": _vm.sale.InvoiceDate,
                          fancy: "",
                        },
                        model: {
                          value: _vm.sale.PaymentBeforeDiscountDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.sale, "PaymentBeforeDiscountDate", $$v)
                          },
                          expression: "sale.PaymentBeforeDiscountDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          value:
                            _vm.sale
                              .UseCreditRestrictionInsteadOfDiscountPercent,
                          label: _vm.$ct("use-credit-restriction"),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setUseCreditRestrictionInsteadOfDiscountPercent(
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.hasDepositModule
                    ? _c(
                        "w-col",
                        { attrs: { xs: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              min: 0,
                              label: _vm.$ct("new-deposit"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.sale.ToCreateDeposit,
                              callback: function ($$v) {
                                _vm.$set(_vm.sale, "ToCreateDeposit", $$v)
                              },
                              expression: "sale.ToCreateDeposit",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hasDepositModule
                    ? _c(
                        "w-col",
                        { attrs: { xs: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              value:
                                _vm.sale.DepositAmount +
                                _vm.sale.ToCreateDeposit,
                              disabled: "",
                              label: _vm.$ct("total-deposit"),
                              fancy: "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-toggle-group",
            {
              on: { input: _vm.saveToggleState },
              model: {
                value: _vm.toggleOther,
                callback: function ($$v) {
                  _vm.toggleOther = $$v
                },
                expression: "toggleOther",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "slot-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [_vm._v(" " + _vm._s(_vm.$ct("toggle-group-other")) + " ")]
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "6" } },
                    [
                      _c("w-select", {
                        attrs: {
                          label: _vm.$ct("reminder"),
                          fancy: "",
                          items: _vm.reminders,
                        },
                        model: {
                          value: _vm.sale.Reminder,
                          callback: function ($$v) {
                            _vm.$set(_vm.sale, "Reminder", $$v)
                          },
                          expression: "sale.Reminder",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "6" } },
                    [
                      _c("app-select-journal", {
                        attrs: {
                          label: _vm.$ct("journal"),
                          fancy: "",
                          "filter-to-journals-with-sale-number": "",
                          disabled: !_vm.hasJournalModule,
                        },
                        model: {
                          value: _vm.sale.JournalID,
                          callback: function ($$v) {
                            _vm.$set(_vm.sale, "JournalID", $$v)
                          },
                          expression: "sale.JournalID",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.isAllowedMultiLanguages
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-custom-language-select", {
                            staticClass: "mtl",
                            attrs: {
                              value: _vm.sale.Lng,
                              label: _vm.$ct("language-select"),
                              fancy: "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setLng($event)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hasRepresentativeModule
                    ? _c(
                        "w-col",
                        [
                          _c("app-default-sale-creator-select", {
                            model: {
                              value: _vm.sale.RepresentativeID,
                              callback: function ($$v) {
                                _vm.$set(_vm.sale, "RepresentativeID", $$v)
                              },
                              expression: "sale.RepresentativeID",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }